import React, {memo, useState, useCallback} from 'react';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import { connect } from "react-redux";

const SimpleParameterSlider = (props) => {
    let {min, max, value} = props.parameter.parameter;
    value = Math.cbrt(value);
    if (props.parameter.min !== undefined) {
        min = props.parameter.min;
    } 
    if (props.parameter.max !== undefined) {
        max = props.parameter.max;
    } 
    return (
        <div className="simple-parameter-slider">
          <ReactBootstrapSlider
            value={value}
            change={(e) => props.onChange(e)}
            step={0.01}
            max={Math.cbrt(max)}
            min={Math.cbrt(min)}
            orientation="horizontal"
            reversed={false}
            />
        </div>
    );
};

const mapStateToProps = (state, props) => {
    if (props.parameter === undefined) {
        return {
            value: 0,
        };
    }

    return {
        value: props.parameter.parameter.get(),
    }
};
 
export default connect(mapStateToProps, null)(SimpleParameterSlider);


